import ReactDOM from "react-dom";
import React from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";


ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);

